/**
 * 组织信息Tab组件
 */

import React from 'react';
import { Descriptions, Tag, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import type { Organization } from '../../../services/organizationAPI';

interface OrganizationInfoTabProps {
    organization: Organization | null;
}

export const OrganizationInfoTab: React.FC<OrganizationInfoTabProps> = ({ organization }) => {
    if (!organization) {
        return (
            <div style={{ textAlign: 'center', padding: 40 }}>
                <p>您尚未加入任何组织</p>
                <Button type="primary" icon={<PlusOutlined />}>
                    创建组织
                </Button>
            </div>
        );
    }

    return (
        <Descriptions bordered column={2}>
            <Descriptions.Item label="组织名称">{organization.name}</Descriptions.Item>
            <Descriptions.Item label="标识">{organization.slug}</Descriptions.Item>
            <Descriptions.Item label="创建者">{organization.owner_name}</Descriptions.Item>
            <Descriptions.Item label="订阅计划">
                <Tag color="blue">{organization.plan}</Tag>
            </Descriptions.Item>
            <Descriptions.Item label="成员数">
                {organization.member_count} / {organization.max_members}
            </Descriptions.Item>
            <Descriptions.Item label="企业邀请码">
                {organization.invitation_code ? (
                    <span>
                        <Tag color="green" style={{ fontSize: '14px', padding: '2px 8px' }}>
                            {organization.invitation_code}
                        </Tag>
                        <Button
                            type="link"
                            size="small"
                            onClick={() => {
                                navigator.clipboard.writeText(organization.invitation_code || '');
                                // 可以加个message提示，但为了从简暂略
                            }}
                        >
                            复制
                        </Button>
                    </span>
                ) : <span style={{ color: '#999' }}>无</span>}
            </Descriptions.Item>
            <Descriptions.Item label="部门数">{organization.department_count}</Descriptions.Item>
            <Descriptions.Item label="描述" span={2}>
                {organization.description || '暂无描述'}
            </Descriptions.Item>
        </Descriptions>
    );
};

export default OrganizationInfoTab;
